import formatMoney from '../formatMoney';
import { formatDisplayMoney } from '../vatDisplay';
import { getDisplaySavingsCents, getDisplaySavingsPercent } from '../vatBasis';
import formatPdpSaleSummary from './formatPdpSaleSummary';

const SR_ONLY_CLASS = 'sr-only';
const HIDDEN_CLASS = 'hidden';
const ATTR_VAT_AMOUNT = 'data-vat-amount';

const formatSaleBadge = (price, compareAtPrice, badgeTemplate) => {
  const compare = Number(compareAtPrice) || 0;
  const salePrice = Number(price) || 0;

  if (compare <= salePrice) return '';

  const displayDiff = getDisplaySavingsCents(compare, salePrice);
  const amount = formatMoney(displayDiff, window.theme.moneyFormat);
  const percent = getDisplaySavingsPercent(compare, salePrice);

  return badgeTemplate.replace(/\{\{\s*amount\s*\}\}/g, amount).replace(/\{\{\s*percent\s*\}\}/g, String(percent));
};

const updatePrice = ({
  priceEl,
  compareAtPriceEl,
  badgeEl,
  saleRowEl,
  price,
  compareAtPrice,
  badgeTemplate,
  isPdp = false,
}) => {
  if (!priceEl) return;

  const compare = Number(compareAtPrice) || 0;
  const salePrice = Number(price) || 0;
  const isOnSale = compare > salePrice;
  const saleSummary = isPdp
    ? formatPdpSaleSummary(salePrice, compare)
    : formatSaleBadge(salePrice, compare, badgeTemplate);

  if (saleRowEl) {
    saleRowEl.classList.toggle(HIDDEN_CLASS, !isOnSale);
  }

  if (badgeEl) {
    const badgeTextEl = badgeEl.querySelector('[data-sale-badge-text]') || badgeEl;
    badgeTextEl.textContent = isOnSale && saleSummary ? saleSummary : '';
  }

  if (compareAtPriceEl) {
    if (isOnSale) {
      compareAtPriceEl.replaceChildren();
      const srEl = document.createElement('span');
      srEl.className = SR_ONLY_CLASS;
      srEl.textContent = window.theme.strings.regularPriceSr || '';
      compareAtPriceEl.appendChild(srEl);
      compareAtPriceEl.appendChild(document.createTextNode(formatDisplayMoney(compare)));
      compareAtPriceEl.classList.remove(HIDDEN_CLASS);
    } else {
      compareAtPriceEl.replaceChildren();
      compareAtPriceEl.removeAttribute(ATTR_VAT_AMOUNT);
      compareAtPriceEl.classList.add(HIDDEN_CLASS);
    }
  }

  priceEl.textContent = formatDisplayMoney(salePrice);
  priceEl.setAttribute(ATTR_VAT_AMOUNT, String(salePrice));

  const variantTotalPriceEl = document.querySelector('[data-product-variant-total-price]');
  if (variantTotalPriceEl) {
    variantTotalPriceEl.textContent = formatDisplayMoney(salePrice);
    variantTotalPriceEl.setAttribute(ATTR_VAT_AMOUNT, String(salePrice));
  }

  if (compareAtPriceEl && isOnSale) {
    compareAtPriceEl.setAttribute(ATTR_VAT_AMOUNT, String(compare));
  }

  const stickyPriceEl = document.querySelector('[data-sticky-product-price]');
  const stickyCompareEl = document.querySelector('[data-sticky-product-compare-at-price]');
  const stickyBadgeEl = document.querySelector('[data-sticky-product-sale-badge]');
  const stickySaleRowEl = document.querySelector('[data-sticky-product-sale-row]');

  if (stickySaleRowEl) {
    stickySaleRowEl.classList.toggle(HIDDEN_CLASS, !isOnSale);
  }

  if (stickyPriceEl) {
    stickyPriceEl.textContent = formatDisplayMoney(salePrice);
    stickyPriceEl.setAttribute(ATTR_VAT_AMOUNT, String(salePrice));
  }

  if (stickyCompareEl) {
    if (isOnSale) {
      stickyCompareEl.replaceChildren();
      const srSticky = document.createElement('span');
      srSticky.className = SR_ONLY_CLASS;
      srSticky.textContent = window.theme.strings.regularPriceSr || '';
      stickyCompareEl.appendChild(srSticky);
      stickyCompareEl.appendChild(document.createTextNode(formatDisplayMoney(compare)));
      stickyCompareEl.classList.remove(HIDDEN_CLASS);
      stickyCompareEl.setAttribute(ATTR_VAT_AMOUNT, String(compare));
    } else {
      stickyCompareEl.replaceChildren();
      stickyCompareEl.removeAttribute(ATTR_VAT_AMOUNT);
      stickyCompareEl.classList.add(HIDDEN_CLASS);
    }
  }

  if (stickyBadgeEl) {
    const stickyBadgeTextEl =
      stickyBadgeEl.querySelector('[data-sale-badge-text]') || stickyBadgeEl;
    stickyBadgeTextEl.textContent = isOnSale && saleSummary ? saleSummary : '';
  }
};

export default updatePrice;
